import React, { Children, useState } from "react";
import Button from "@mui/material/Button";

// import JS files
import MuiTheme from "./MuiTheme";

// import Others files

const MuiButton = ({
  onClick,
  variant,
  icon,
  color,
  text,
  margin,
  size,
  type,
  isFullWidth,
  disabled,
  withoutOnClick = false,
}) => {
  let windowWidth = window.screen.width;

  return (
    <>
      <MuiTheme>
        <div className={`${margin}`}>
          <Button
            className={isFullWidth ? "w-full" : ""}
            onClick={!withoutOnClick ? () => onClick() : undefined}
            variant={variant}
            endIcon={icon}
            color={color}
            size={size}
            type={type}
            disabled={disabled}
          >
            {text}
          </Button>
        </div>
      </MuiTheme>
    </>
  );
};

export default MuiButton;
